import translationPt from './translationPt';
import translationEn from './translationEn';
import translationSp from './translationSp';

const translations = {
	Pt: translationPt,
	En: translationEn,
	Sp: translationSp,
};

export default translations;

export function translate(language) {
	return translations[language.symbol];
}



// WEBPACK FOOTER //
// ./src/assets/translations.js